import React, { useRef, useState } from "react"
import { useFormik } from "formik"
import { useTracking } from "react-tracking"
import { getActiveFromValue, InputSelect } from "../../components/input-select/input-select"
import { Card } from "../../components/card"
import { decodeFormData, encodeBase64 } from "../../modules/functions"
import { ConversationBubble } from "../../components/conversation-bubble"
import { USDIcon } from "./usd-icon"
import { CardFooter } from "../../components/card-footer"
import { formikConfig } from "../../modules/formik/config"
import { fullValidationSchema } from "../../modules/formik/validation"
import { Root } from "../../components/root"

import "./style.scss"

const App = () => {
    const [isLoading, setIsLoading] = useState(false)

    const chpRef = useRef() as React.MutableRefObject<HTMLDivElement>
    const formData = decodeFormData(window.location.search)
    const formik = useFormik({
        ...formikConfig,
        initialValues: { ...formikConfig.initialValues, count: "1", mx: false, ...formData },
        validationSchema: fullValidationSchema,
    })
    const { trackEvent } = useTracking()

    const track = () => {
        trackEvent({
            event: "genericEvent",
            category: "click",
            action: "click select field",
            label: "count",
        })
    }

    function trackedSubmitForm() {
        setIsLoading(true)
        trackEvent({
            event: "genericEvent",
            category: "click",
            action: "click button",
            label: "chooseplan",
        })

        formik.submitForm().then(() => {
            trackEvent({
                event: "genericEvent",
                category: "submit",
                action: "submit button",
                label: "chooseplan",
            })
            const values = { ...JSON.parse(JSON.stringify(formik.values)), mx: undefined }
            window.location.href = `/welcome-to-black-pearl-mail?bpm_fd=${encodeBase64(JSON.stringify(values))}`
        })
    }

    const countConfig = [
        {
            label: (
                <div>
                    Just me <span className="pull-right">$49/mo.</span>
                </div>
            ),
            value: "1",
        },
        {
            label: (
                <div>
                    2 - 5 people <span className="pull-right">$99/mo.</span>
                </div>
            ),
            value: "2-5",
        },
        {
            label: (
                <div>
                    6 - 15 people <span className="pull-right">$150/mo.</span>
                </div>
            ),
            value: "6-15",
        },
        {
            label: (
                <div>
                    16 - 50 people <span className="pull-right">$250/mo.</span>
                </div>
            ),
            value: "16-50",
        },
        {
            label: (
                <div>
                    51 or more <span className="pull-right">custom plan</span>
                </div>
            ),
            value: "51+",
        },
    ]

    return (
        <Root id="chp" ref={chpRef}>
            <Card>
                <ConversationBubble
                    header="Our plans scale to suit your needs."
                    para={`Tell me how many people will be branding their emails at ${formik.values.orgname}.`}
                />
                <ul>
                    <li>Gain traffic, increase followers & boost sales with banner messaging.</li>
                    <li>Professional email signatures sent from any device.</li>
                    <li>Live email tracking empowers you to take the right action at the right time.</li>
                    <li>Dedicated support from an email expert with no setup fees or contracts.</li>
                </ul>
                <hr></hr>
                <InputSelect
                    label="Choose plan"
                    active={getActiveFromValue(formik.values.count, countConfig)}
                    options={countConfig}
                    id="count"
                    tooltip={
                        <div>
                            <span className="chp-usd">$ in USD</span>
                            <USDIcon />
                        </div>
                    }
                    callback={(option) => {
                        formik.setFieldValue("count", option.value, false)
                        formik.setFieldError("count", undefined)
                    }}
                    onFocus={track}
                    disabled={false}
                    menuPlacement="top"
                />
                <CardFooter
                    className="chp-next"
                    nextAction={trackedSubmitForm}
                    currentCount={2}
                    maxCount={3}
                    disabled={isLoading}
                />
            </Card>
        </Root>
    )
}

export default App
